import React, { useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Form,
  FormFeedback,
  Label,
  Input,
} from "reactstrap"
import Select from "react-select"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

// Redux
import { useNavigate } from "react-router-dom"
import { optionGroup, pulaActivityOptions } from "constants/awards"
const postGroupOption = [
  {
    options: [
      { label: "Twice a week", value: "Twice a week" },
      { label: "Twice a month", value: "Twice a month" },
      { label: "Once 3-4 months", value: "Once 3-4 months" },
      { label: "Very rare", value: "Very rare" },
    ],
  },
]
const reviewGroupOption = [
  {
    options: [
      { label: "Below 20", value: "Below 20" },
      { label: "Below 50", value: "Below 50" },
      { label: "Below 100", value: "Below 100" },
      { label: "Lost the count", value: "Lost the count" },
    ],
  },
]
const AwardsNew = props => {
  const history = useNavigate()

  const [selectedCategory, setSelectedCategory] = useState(null)
  const [subOptions, setSubOptions] = useState([])
  const [postOptions, setPostOptions] = useState(null)
  const [reviewOptions, setReviewOptions] = useState(null)

  const handleCategoryChange = selected => {
    setSelectedCategory(selected)
    setSubOptions(selected?.subcategories || [])
    validation.setFieldValue("category", selected?.value)
    validation.setFieldValue("sub_category", "")
  }

  const handleSubCategoryChange = selected => {
    validation.setFieldValue("sub_category", selected?.value)
  }

  function handlePostOptionsChanges(postOptions) {
    setPostOptions(postOptions)
  }
  function handleReviewOptionsChanges(reviewOptions) {
    setReviewOptions(reviewOptions)
  }

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      full_name: "",
      email_id: "",
      contact_no: "",
      wa_mobile_no: "",
      fb_profile_link: "",
      fb_page_link: "",
      insta_link: "",
      category: "",
      sub_category: "",
      why_participate: "",
      achievements: "",
      pula_activity: "",
      post_frequency: "",
      review_count: "",
      review_links: ["", "", "", "", ""],
      attended_events: "",
      attended_event_names: "",
    },
    validationSchema: Yup.object({
      full_name: Yup.string().required("Please Enter Your Full Name"),
      email_id: Yup.string().required("Please Enter Your Email"),
      contact_no: Yup.string().required("Please Enter Your Contact Number"),
      wa_mobile_no: Yup.string().required("Please Enter Your Whatsapp Number"),
      fb_profile_link: Yup.string().url("Invalid URL"),
      fb_page_link: Yup.string().url("Invalid URL"),
      fb_page_link: Yup.string().url("Invalid URL"),
      insta_link: Yup.string().url("Invalid URL"),
      category: Yup.string().required("Please Select a Category"),
      sub_category: Yup.string().required("Please Select a Subcategory"),
      why_participate: Yup.string().required(
        "Please Explain Why You Want to Participate"
      ),
      achievements: Yup.string().required("Please Share Your Achievements"),
      pula_activity: Yup.string().required(
        "Please Describe Your PULA Activity"
      ),
      post_frequency: Yup.string().required(
        "Please Specify Your Post Frequency"
      ),
      review_count: Yup.string().required("Please Specify Your Review Count"),
      review_links: Yup.array()
        .of(Yup.string().url("Must be a valid URL").nullable())
        .test(
          "min-3-links",
          "Please provide at least 3 valid review links",
          arr => arr.filter(val => val && val.trim() !== "").length >= 3
        ),
      attended_events: Yup.string().required(
        "Please Specify If You Attended Any Events"
      ),
    }),
    onSubmit: values => {
      handleSubmit(values)
    },
  })

  const handleSubmit = async value => {

    value.review_links?.forEach((link, index) => {
      value[`review_link_${index + 1}`] = link
    })
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/awards/add-award`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(value),
        }
      )

      if (!response.ok) throw new Error("Award Form failed")

      const data = await response.json()
      handlePay(data.data)
    } catch (error) {
      console.error("❌ Award Form error:", error.message)
      alert("Unable to add award form.")
    }
  }

  const loadRazorpayScript = () => {
    return new Promise(resolve => {
      if (window.Razorpay) return resolve(true)

      const script = document.createElement("script")
      script.src = "https://checkout.razorpay.com/v1/checkout.js"
      script.onload = () => resolve(true)
      script.onerror = () => resolve(false)
      document.body.appendChild(script)
    })
  }

  const handlePay = async submitAwardFormResponse => {

    const scriptLoaded = await loadRazorpayScript()
    if (!scriptLoaded) {
      toast.error(
        "⚠️ Razorpay SDK failed to load. Check your internet connection."
      )
      return
    }
    try {
      const orderUrl = `${process.env.REACT_APP_API_URL}/awards/create-order`

      const response = await fetch(orderUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          amount: process.env.REACT_APP_AWARD_AMOUNT,
          currency: "INR",
        }),
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      const options = {
        key: process.env.REACT_APP_RZRPAY_KEY, // Razorpay Key ID
        amount: data.order.amount,
        currency: data.order.currency,
        name: submitAwardFormResponse.full_name,
        description: "Award Payment",
        order_id: data.order.id,
        handler: async function (response) {
          try {
            const verifyUrl = `${process.env.REACT_APP_API_URL}/awards/verify`
            const res = await fetch(verifyUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                award_id: submitAwardFormResponse.award_id,
                amount: process.env.REACT_APP_AWARD_AMOUNT,
                currency: data.order.currency,
                name: submitAwardFormResponse.full_name,
                email_id: submitAwardFormResponse.email_id,
                contact: submitAwardFormResponse.contact_no,
              }),
            })

            const result = await res.json()
            if (result.success) {
              toast.success("🎉 Payment successful!")
              history("/congratulations", { replace: true })
            } else {
              toast.error("❌ Payment failed. Please try again.")
            }
          } catch (error) {
            console.error("Verification error:", error)
            toast.error("⚠️ Payment verification failed.")
          }
        },
        prefill: {
          name: submitAwardFormResponse.full_name,
          email: submitAwardFormResponse.email_id,
          contact: submitAwardFormResponse.contact_no,
        },
        theme: {
          color: "#3399cc",
        },
      }

      const rzp = new window.Razorpay(options)
      rzp.open()
    } catch (err) {
      console.error("Payment initiation error:", err)
      toast.error("⚠️ Unable to start payment. Please try again later.")
    }
  }

  document.title = "Awards | PULA"
  return (
    <>
      <div className="newaward-maincontainer">
        <Row className="newaward-row">
          <Col xs={12} md={7} xl={7}>
            <Card className="overflow-hidden">
              <CardBody>
                <h1 className="heading-tag">Awards Form</h1>
                <div>
                  <Form
                    className="mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    action="#"
                  >
                    <div className="row">
                      <div className="mb-4 col-md-6">
                        <Label className="form-label" htmlFor="full_name">
                          Full Name
                        </Label>
                        <Input
                          name="full_name"
                          className="form-control"
                          placeholder="Enter Full Name"
                          type="text"
                          id="full_name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.full_name || ""}
                          invalid={
                            validation.touched.full_name &&
                            validation.errors.full_name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.full_name &&
                        validation.errors.full_name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.full_name}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-4 col-md-6">
                        <Label className="form-label" htmlFor="email_id">
                          Email
                        </Label>
                        <Input
                          name="email_id"
                          className="form-control"
                          placeholder="Enter Email"
                          type="email_id"
                          id="email_id"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email_id || ""}
                          invalid={
                            validation.touched.email_id &&
                            validation.errors.email_id
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email_id &&
                        validation.errors.email_id ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email_id}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-4 col-md-6">
                        <Label className="form-label" htmlFor="contact_no">
                          Contact Number
                        </Label>
                        <Input
                          name="contact_no"
                          className="form-control"
                          placeholder="Enter Contact Number"
                          type="tel"
                          id="contact_no"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.contact_no || ""}
                          invalid={
                            validation.touched.contact_no &&
                            validation.errors.contact_no
                              ? true
                              : false
                          }
                        />
                        {validation.touched.contact_no &&
                        validation.errors.contact_no ? (
                          <FormFeedback type="invalid">
                            {validation.errors.contact_no}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-4 col-md-6">
                        <Label className="form-label" htmlFor="wa_mobile_no">
                          Whatsapp Number
                        </Label>
                        <Input
                          name="wa_mobile_no"
                          className="form-control"
                          placeholder="Enter Whatsapp Number"
                          type="tel"
                          id="wa_mobile_no"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.wa_mobile_no || ""}
                          invalid={
                            validation.touched.wa_mobile_no &&
                            validation.errors.wa_mobile_no
                              ? true
                              : false
                          }
                        />
                        {validation.touched.wa_mobile_no &&
                        validation.errors.wa_mobile_no ? (
                          <FormFeedback type="invalid">
                            {validation.errors.wa_mobile_no}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-4 col-md-6">
                        <Label className="form-label" htmlFor="fb_profile_link">
                          Facebook Profile Link
                        </Label>
                        <Input
                          name="fb_profile_link"
                          className="form-control"
                          placeholder="Enter Facebook Profile Link"
                          type="url"
                          id="fb_profile_link"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.fb_profile_link || ""}
                          invalid={
                            validation.touched.fb_profile_link &&
                            validation.errors.fb_profile_link
                              ? true
                              : false
                          }
                        />
                        {validation.touched.fb_profile_link &&
                        validation.errors.fb_profile_link ? (
                          <FormFeedback type="invalid">
                            {validation.errors.fb_profile_link}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-4 col-md-6">
                        <Label className="form-label" htmlFor="fb_page_link">
                          Facebook Page Link
                        </Label>
                        <Input
                          name="fb_page_link"
                          className="form-control"
                          placeholder="Enter Facebook Page Link"
                          type="url"
                          id="fb_page_link"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.fb_page_link || ""}
                          invalid={
                            validation.touched.fb_page_link &&
                            validation.errors.fb_page_link
                              ? true
                              : false
                          }
                        />
                        {validation.touched.fb_page_link &&
                        validation.errors.fb_page_link ? (
                          <FormFeedback type="invalid">
                            {validation.errors.fb_page_link}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-4 col-md-6">
                        <Label className="form-label" htmlFor="insta_link">
                          Instagram Page Link
                        </Label>
                        <Input
                          name="insta_link"
                          className="form-control"
                          placeholder="Enter Instagram Page Link"
                          type="url"
                          id="insta_link"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.insta_link || ""}
                          invalid={
                            validation.touched.insta_link &&
                            validation.errors.insta_link
                              ? true
                              : false
                          }
                        />
                        {validation.touched.insta_link &&
                        validation.errors.insta_link ? (
                          <FormFeedback type="invalid">
                            {validation.errors.insta_link}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-4 col-md-6 col-12">
                        <div className="mb-4">
                          <Label className="form-label" htmlFor="pula_activity">
                            How active are you on the PULA FB group?
                          </Label>

                          <Select
                            id="pula_activity"
                            name="pula_activity"
                            options={pulaActivityOptions}
                            value={pulaActivityOptions.find(
                              opt =>
                                opt.value === validation.values.pula_activity
                            )}
                            onChange={selectedOption => {
                              validation.setFieldValue(
                                "pula_activity",
                                selectedOption?.value
                              )
                            }}
                            onBlur={() =>
                              validation.setFieldTouched("pula_activity", true)
                            }
                            classNamePrefix="select2-selection"
                            className="customselect"
                          />

                          {validation.touched.pula_activity &&
                            validation.errors.pula_activity && (
                              <FormFeedback className="d-block" type="invalid">
                                {validation.errors.pula_activity}
                              </FormFeedback>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-4 col-md-6">
                        <Label className="form-label" htmlFor="category">
                          Which category would you like to apply for?
                        </Label>

                        <Select
                          id="category"
                          name="category"
                          value={selectedCategory}
                          onChange={handleCategoryChange}
                          options={optionGroup}
                          classNamePrefix="select2-selection"
                          className="customselect"
                        />
                        {validation.touched.category &&
                          validation.errors.category && (
                            <FormFeedback className="d-block" type="invalid">
                              {validation.errors.category}
                            </FormFeedback>
                          )}
                      </div>
                      <div className="mb-4 col-md-6">
                        <Label className="form-label" htmlFor="sub_category">
                          Subcategory
                        </Label>

                        <Select
                          id="sub_category"
                          name="sub_category"
                          value={subOptions.find(
                            option =>
                              option.value === validation.values.sub_category
                          )}
                          onChange={handleSubCategoryChange}
                          options={subOptions}
                          isDisabled={!selectedCategory}
                          classNamePrefix="select2-selection"
                          className="customselect"
                        />
                        {validation.touched.sub_category &&
                          validation.errors.sub_category && (
                            <FormFeedback className="d-block" type="invalid">
                              {validation.errors.sub_category}
                            </FormFeedback>
                          )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 col-lg-6">
                        <div className="mb-4">
                          <Label
                            className="form-label"
                            htmlFor="why_participate"
                          >
                            Why would you want to participate?
                          </Label>

                          <textarea
                            name="why_participate"
                            id="why_participate"
                            className={`form-control ${
                              validation.touched.why_participate &&
                              validation.errors.why_participate
                                ? "is-invalid"
                                : ""
                            }`}
                            rows="3"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.why_participate || ""}
                          />

                          {validation.touched.why_participate &&
                          validation.errors.why_participate ? (
                            <FormFeedback type="invalid">
                              {validation.errors.why_participate}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-12 col-lg-6">
                        <div className="mb-4">
                          <Label className="form-label" htmlFor="achievements">
                            Achievements till date?
                          </Label>

                          <textarea
                            name="achievements"
                            id="achievements"
                            className={`form-control ${
                              validation.touched.achievements &&
                              validation.errors.achievements
                                ? "is-invalid"
                                : ""
                            }`}
                            rows="3"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.achievements || ""}
                          />

                          {validation.touched.achievements &&
                            validation.errors.achievements && (
                              <FormFeedback type="invalid">
                                {validation.errors.achievements}
                              </FormFeedback>
                            )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 col-md-5">
                        <div className="mb-4">
                          <Label className="form-label mb-2 d-flex">
                            How often do you post?
                          </Label>
                          <Select
                            id="post_category"
                            name="post_category"
                            value={postOptions}
                            onChange={() => {
                              handlePostOptionsChanges()
                            }}
                            options={postGroupOption}
                            classNamePrefix="select2-selection"
                            className="customselect"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-7">
                        <div className="mb-4">
                          <Label className="form-label mb-2 d-flex">
                            How many reviews would you have on PULA?
                          </Label>
                          <Select
                            id="review_catagory"
                            name="review_catagory"
                            value={reviewOptions}
                            onChange={() => {
                              handleReviewOptionsChanges()
                            }}
                            options={reviewGroupOption}
                            classNamePrefix="select2-selection"
                            className="customselect"
                          />
                        </div>
                      </div>
                    </div>

                    {/* <div className="mb-4">
                      <Label className="form-label mb-3 d-flex">
                        How often do you post?
                      </Label>

                      {[
                        "Twice a week",
                        "Twice a month",
                        "Once 3-4 months",
                        "Very rare",
                      ].map((option, index) => (
                        <div
                          className="form-check form-check-inline"
                          key={index}
                        >
                          <input
                            className={`form-check-input ${
                              validation.touched.post_frequency &&
                              validation.errors.post_frequency
                                ? "is-invalid"
                                : ""
                            }`}
                            type="radio"
                            id={`post_frequency_${index}`}
                            name="post_frequency"
                            value={option}
                            checked={
                              validation.values.post_frequency === option
                            }
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`post_frequency_${index}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))}

                      {validation.touched.post_frequency &&
                        validation.errors.post_frequency && (
                          <div className="invalid-feedback d-block">
                            {validation.errors.post_frequency}
                          </div>
                        )}
                    </div> */}
                    {/* {[
                        "Below 20",
                        "Below 50",
                        "Below 100",
                        "Lost the count",
                      ].map((option, index) => (
                        <div
                          className="form-check form-check-inline"
                          key={index}
                        >
                          <input
                            className={`form-check-input ${
                              validation.touched.review_count &&
                              validation.errors.review_count
                                ? "is-invalid"
                                : ""
                            }`}
                            type="radio"
                            id={`review_count_${index}`}
                            name="review_count"
                            value={option}
                            checked={validation.values.review_count === option}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`review_count_${index}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))}
                      {validation.touched.review_count &&
                        validation.errors.review_count && (
                          <div className="invalid-feedback d-block">
                            {validation.errors.review_count}
                          </div>
                        )} */}

                    <div className="mb-4">
                      <Label className="form-label mb-3">
                        Please share links of a few of your reviews (minimum 3)
                      </Label>

                      {validation.values.review_links.map((link, index) => (
                        <Input
                          key={index}
                          type="text"
                          name={`review_links[${index}]`}
                          className={`form-control mb-3 ${
                            validation.touched.review_links &&
                            validation.errors.review_links &&
                            validation.errors.review_links[index]
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder={`Link ${index + 1}`}
                          value={validation.values.review_links[index]}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                        />
                      ))}

                      {typeof validation.errors.review_links === "string" && (
                        <FormFeedback className="d-block" type="invalid">
                          {validation.errors.review_links}
                        </FormFeedback>
                      )}
                    </div>

                    <div className="mb-4">
                      <Label className="form-label d-flex">
                        Have you attended any of PULA's events?{" "}
                      </Label>

                      {["Yes", "No"].map((option, index) => (
                        <div
                          className="form-check form-check-inline"
                          key={index}
                        >
                          <input
                            className={`form-check-input ${
                              validation.touched.attended_events &&
                              validation.errors.attended_events
                                ? "is-invalid"
                                : ""
                            }`}
                            type="radio"
                            id={`attended_events_${index}`}
                            name="attended_events"
                            value={option}
                            checked={
                              validation.values.attended_events === option
                            }
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`attended_events_${index}`}
                          >
                            {option}
                          </label>
                        </div>
                      ))}

                      {validation.touched.attended_events &&
                        validation.errors.attended_events && (
                          <div className="invalid-feedback d-block">
                            {validation.errors.attended_events}
                          </div>
                        )}
                    </div>
                    {validation.values.attended_events === "Yes" && (
                      <div className="mb-4">
                        <Label
                          className="form-label"
                          htmlFor="attended_event_names"
                        >
                          Which ones?
                        </Label>
                        <Input
                          name="attended_event_names"
                          className="form-control"
                          placeholder="Enter Which Events You Attended"
                          type="text"
                          id="attended_event_names"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.attended_event_names || ""}
                          invalid={
                            validation.touched.attended_event_names &&
                            validation.errors.attended_event_names
                              ? true
                              : false
                          }
                        />
                        {validation.touched.attended_event_names &&
                        validation.errors.attended_event_names ? (
                          <FormFeedback type="invalid">
                            {validation.errors.attended_event_names}
                          </FormFeedback>
                        ) : null}
                      </div>
                    )}

                    <div className="row">
                      <div className="col-12 text-center d-flex justify-content-center mt-2">
                        <button className="primary-button" type="submit">
                          Submit
                        </button>
                      </div>
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xs={12} md={5} xl={5}>
            <div className="content-boxnew">
              <h2 className="title">
                Come join the exclusive&nbsp;
                <br />
                <span className="main-highlight">
                  PULA Business Networking Meet!
                </span>
              </h2>
              <p>
                <span className="highlighted">Date</span> - 18th December,
                Thursday
              </p>
              <p>
                <span className="highlighted">Time</span> - 3pm to 6pm{" "}
              </p>
              <p>
                <span className="highlighted">Venue</span> - The Orbett Hotel
                Banquet, Apte Road, Deccan, Pune
              </p>
            </div>
          </Col>
        </Row>
        <div className="mt-5 text-center">
          <p className="copyrights">
            © {new Date().getFullYear()} PULA. Crafted with{" "}
            <i className="mdi mdi-heart text-danger" /> by Autuskey
          </p>
        </div>
      </div>
    </>
  )
}
export default AwardsNew
